<template>
  <div>
    <LandApplicationBanner></LandApplicationBanner>
    <div class="tags-div">
      <div class="tags-center">
        <el-tabs
          v-model="activeName"
          @tab-click="tabsClick"
        >
          <el-tab-pane
            label="全部"
            name="case-all"
          >
            <div style="margin-bottom:56px">
              <caseAll ref="caseAll"></caseAll>
            </div>
          </el-tab-pane>
          <el-tab-pane
            v-if="solutionList[0]"
            :label="solutionList[0].clientGroup"
            name="case-developer"
          >
            <div style="margin-bottom:56px">
              <CaseDeveloper
                v-if="solutionList[0].clientGroup==='建设方'"
                ref="caseDeveloper"
              ></CaseDeveloper>
              <CaseContractor
                v-else-if="solutionList[0].clientGroup==='施工方'"
                ref="caseContractor"
              ></CaseContractor>
            </div>

          </el-tab-pane>
          <el-tab-pane
            v-if="solutionList[1]"
            :label="solutionList[1].clientGroup"
            name="case-contractor"
          >
            <div style="margin-bottom:56px">
              <CaseContractor
                v-if="solutionList[1].clientGroup==='施工方'"
                ref="caseContractor"
              ></CaseContractor>
              <CaseDeveloper
                v-else-if="solutionList[1].clientGroup==='建设方'"
                ref="caseDeveloper"
              ></CaseDeveloper>
            </div>

          </el-tab-pane>
        </el-tabs>
      </div>

    </div>
  </div>
</template>

<script>
import LandApplicationBanner from './components/LandApplicationBanner.vue'
import { getSolutionList } from '@/api/landing'
import { scrollTopFun } from '@/utils/universalFun.js'
import caseAll from './components/CaseAll.vue'
import CaseDeveloper from './components/CaseDeveloper.vue'
import CaseContractor from './components/CaseContractor.vue'
export default {
  name: 'landApplication',
  components: {
    LandApplicationBanner,
    caseAll,
    CaseDeveloper,
    CaseContractor
  },
  mounted () {
    this.getList()
  },
  data () {
    return {
      activeName: 'case-all',
      solutionList: []
    }
  },
  methods: {
    // 获取列表
    getList () {
      // 查询解决方案
      getSolutionList().then(res => {
        const { code, data, message } = res
        if (code === 200) {
          this.solutionList = data
        } else {
          this.solutionList = []
          message && this.$message.error(message)
        }
      }).catch(() => {
        this.solutionList = []
      })
    },
    // 点击应用案例
    caseClick (caseUrl) {
      window.open(caseUrl, '_blank')
    },
    // 返回首页
    tabsClick (item) {
      switch (item.label) {
        case '全部':
          this.$refs.caseAll.pageOne()
          break
        case '建设方':
          this.$refs.caseDeveloper.pageOne()
          break
        case '施工方':
          this.$refs.caseContractor.pageOne()
          break
      }
      this.toTop()
    },
    // 回到顶部
    toTop () {
      scrollTopFun()
    }
  }
}
</script>

<style lang="scss" scoped>
.tags-div {
  // height: 50px;
  // background: #ffffff;
  .tags-center {
    // width: 1200px;
    // height: 1154px;
    margin: auto;
    //取消竖线，内容不能被选择
    -webkit-user-select: none; /*谷歌 /Chrome*/
    -moz-user-select: none; /*火狐/Firefox*/
    -ms-user-select: none; /*IE 10+*/
    user-select: none;
    ::v-deep .el-tabs__header {
      min-width: 1200px;
      height: 50px;
      line-height: 50px;
      background: #ffffff;
      margin: 0 auto 0 auto;
    }
    ::v-deep .el-tabs .el-tabs__nav-wrap::after {
      height: 0px;
    }
    ::v-deep .el-tabs__nav {
      left: 50%;
      transform: translateX(-50%) !important;
    }
    ::v-deep .el-tabs__item {
      font-size: 14px;
      font-weight: 400;
      color: #1f1f1f;
      line-height: 22px;
    }
    ::v-deep .el-tabs__item:hover {
      color: #4499ff;
    }
    ::v-deep .el-tabs__item.is-active {
      color: #4499ff;
    }
    ::v-deep .el-tabs__content {
      width: 100%;
      background: #f5f8fa;
    }
  }
}
</style>
